import _defineProperty from "/var/jenkins_home/workspace/tingle.caa77636-11e8-4573-9fa8-b0d26a83c900/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// ignore-string-externalization
//
import React from 'react';
import { useTracking } from '../Tracking';
import { PageBreakerModule } from './PageBreakerModule';
import { RelatedLinksModule } from './RelatedLinksModule';
import { FAQLinksModule } from './FAQLinksModule';
import { MiniCarouselNoHeroModule } from './MiniCarouselNoHeroModule';
import { HeaderModule } from './HeroHeaderModule';
import { ModuleCarousel } from './ModuleCarousel/ModuleCarousel';
import { SingleTestimonialModule } from './SingleTestimonialModule';
import { TwoUpModule } from './TwoUpFeaturedContentModule';
import { ThreeUpModule } from './ThreeUpFeaturedContentModule';
import { heroNarrativeCarouselModuleCreator } from './HeroNarrativeCarouselModule';
import { HeroBodyModule } from './HeroBodyModule';
import { HeroTestimonial } from './HeroNarrativeCarouselModule/Options/HeroTestimonial';
import { HeroDescription } from './HeroNarrativeCarouselModule/Options/HeroDescription';
import { HeroCaseStudy } from './HeroNarrativeCarouselModule/Options/HeroCaseStudy';
import { GroupTestimonialModule } from './GroupTestimonialModule';
import { EventListModule } from './EventListModule';
import { EditorialGridModule } from './EditorialGridModule';
import { VideoModule } from './VideoModule';
import { RelatedStoriesListModule } from './RelatedStoriesListModule';
import { ArticleHeaderModule } from './ArticleHeaderModule';
import { ArticleModule } from './ArticleModule';
import { FeaturedContentModule } from './FeaturedContentModule';
import { AnimationContext, useAnimations, customThreshold } from '../ui';
import { ArticleFeedbackModule } from './ArticleFeedbackModule';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Module = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var contentType = props.contentType,
      _props$shouldAnimate = props.shouldAnimate,
      shouldAnimate = _props$shouldAnimate === void 0 ? true : _props$shouldAnimate,
      _props$isVisible = props.isVisible,
      isVisible = _props$isVisible === void 0 ? false : _props$isVisible,
      _props$title = props.title,
      title = _props$title === void 0 ? '' : _props$title;
  var ModuleComponent = MODULE_COMPONENTS[contentType];
  var shown = React.useRef(false);

  var _useAnimations = useAnimations(contentType, shouldAnimate, customThreshold(contentType)),
      animationContext = _useAnimations.animationContext,
      animationRef = _useAnimations.animationRef;

  var _useTracking = useTracking(),
      sendEvent = _useTracking.sendEvent;

  React.useEffect(function () {
    if (isVisible && ModuleComponent && !shown.current) {
      shown.current = true;
      sendEvent({
        eventCategory: "Frodor - module-".concat(contentType),
        eventAction: 'view',
        eventLabel: title
      });
    }
  }, [isVisible]);

  if (ModuleComponent) {
    return /*#__PURE__*/_jsx(AnimationContext.Provider, {
      value: animationContext,
      children: /*#__PURE__*/_jsx(ModuleComponent, _objectSpread(_objectSpread({}, props), {}, {
        ref: mergeRefs(ref, animationRef)
      }))
    });
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: ["Module type \"", contentType, "\" not found"]
  });
});
var Carousel = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx(ModuleCarousel, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    Module: Module
  }));
});
var MODULE_COMPONENTS = {
  articleModule: ArticleModule,
  faqLinksModule: FAQLinksModule,
  pageBreakerModule: PageBreakerModule,
  editorialGridModule: EditorialGridModule,
  singleFeatureModule: MiniCarouselNoHeroModule,
  singleTestimonial: SingleTestimonialModule,
  groupTestimonial: GroupTestimonialModule,
  featuredContent2Up: TwoUpModule,
  featuredContent3up: ThreeUpModule,
  relatedLinksModule: RelatedLinksModule,
  headerModule: HeaderModule,
  heroBodyModule: HeroBodyModule,
  heroBodyCarousel: Carousel,
  heroHeaderCarousel: Carousel,
  heroNarrativeCarousel: heroNarrativeCarouselModuleCreator(Module),
  heroNarrativeQuoteSlide: HeroTestimonial,
  heroNarrativeTextSlide: HeroDescription,
  heroCaseStudyCover: HeroCaseStudy,
  infoHelpfulModule: ArticleFeedbackModule,
  eventList: EventListModule,
  relatedStoriesList: RelatedStoriesListModule,
  videoModule: VideoModule,
  featuredContentModule: FeaturedContentModule,
  articleHeaderModule: ArticleHeaderModule
};

var mergeRefs = function mergeRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  var filteredRefs = refs.filter(Boolean);
  if (!filteredRefs.length) return null;
  if (filteredRefs.length === 1) return filteredRefs[0];
  return function (inst) {
    var _iterator = _createForOfIteratorHelper(filteredRefs),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var elementRef = _step.value;

        if (typeof elementRef === 'function') {
          elementRef(inst);
        } else if (elementRef) {
          elementRef.current = inst;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };
};

export { ModuleCarousel };